/* global jQuery,location */
(function ($) {
  $(function() {
    var windowHeight = $(window).innerHeight();
    var headerHeight = $('#masthead').innerHeight();
    var affixheight = 0;
    var openCb = $('.open-cb');
    if ($('#menu-affix').is(':visible')) {
      affixheight = 54;
    }
    function setHeight () {
      $('.full-h').css('min-height', windowHeight - headerHeight);
      $('.full-h-tot').css('min-height', windowHeight);
      $('.full-h-tot-menu').css('min-height', windowHeight - 30);
      $('.full-h-affix').css('min-height', windowHeight - headerHeight - affixheight);
    }
    setHeight();
    $(window).on('resize',function () {
      windowHeight = $(window).innerHeight();
      headerHeight = $('#masthead').innerHeight();
      setHeight();
      }).bind('orientationchange', function(event) {
      windowHeight = $(window).innerHeight();
      headerHeight = $('#masthead').innerHeight();
      setHeight();
    });
    var $carousel_singular = $('#carousel-singular');
    $carousel_singular.owlCarousel({
      nav: false,
      dotsEach: true,
      loop: true,
      items: 1, // 10 items above 1000px browser width
      info: true,
      lazyLoad: true,
      navContainer: '#carousel-singular-controls',
      navText:['<span class="fa fa-chevron-left green-light"></span>','<span class="fa fa-chevron-right green-light"></span>'],
      onChanged: function (event) {
        if (event.page.index < 0) return;
        var caption = $carousel_singular.find('.owl-item:not(.cloned) .item').get(event.page.index).dataset.caption;
        $('#carousel-singular-nav > span').text(caption);
      }
    });
  });
})(jQuery);



// WEBPACK FOOTER //
// ./src/js/custom.js